<template>
	<div class="popup-form__wrap" :id="data.popupId">
		<transition name="fade-popup-form" appear>
			<div class="popup-form">
				<div class="popup-form__overlay" @click="closePopup"></div>
				<div class="popup-form__box">
					<div class="popup-details__wrap">
						<span class="popup-details__title section-title">
							{{ data.popupDetailsTitle }}
						</span>
						<div class="popup-details__info">
							<ul>
								<li class="popup-details__info-inner">
									<div class="color-picker__item" style="display: flex; justify-content:space-between">
										<div style="display: flex; align-items: center">
											<span class="color-picker__item-color" :style="{background: data.items.color}"></span>
											{{data.items.stage_name}}
										</div>
										<span class="color-picker__item-date">{{ changeDateFormat(data.items.created_at) }}</span>
									</div>
									<div class="popup-details__info-inner-content">
										<span class="popup-details__content popup-details__content--label" v-if="data.items.popup_date && data.items.popup_date !== '0' && active !== data.items.id">Date:</span>
										<span class="popup-details__content popup-details__content--input" v-if="data.items.popup_date && data.items.popup_date !== '0' && active !== data.items.id">{{ changeDateFormat(data.items.popup_date) }}</span>
										<PartCalendar
											v-show="active === data.items.id"
											:data="DataCalendar"
											v-model="data.items.popup_date"
											ref="note_calendar"
											:show="!!data.items.datepicker"
										/>
									</div>
									<div class="popup-details__info-inner-content popup-details__info-inner-content--note">
										<span class="popup-details__content popup-details__content--label" v-if="data.items.body">Note:</span>
										<div class="popup-details__content-note">
											<PartInputTextarea
												v-if="active === data.items.id"
												:data="DateTextNote"
												v-model="data.items.body"
											/>
											<pre class="popup-details__content popup-details__content--input" v-else v-html="data.items.body"></pre>
											<a @click="saveNote(data.items)" v-if="active === data.items.id">
												<SvgIcon class="note-icon" iconName="ico-save"/>
											</a>
											<a @click="editNote(index, data.items)" v-if="active !== data.items.id">
												<SvgIcon class="note-icon" iconName="ico-edit"/>
											</a>
											<a @click="closeNote()" v-if="active === data.items.id">
												<SvgIcon class="note-icon" iconName="ico-close-sm"/>
											</a>
										</div>
										<div class="popup-details__content-history-wrap" v-if="active === '' && (edited || (historyData && historyData.length && (historyData[0].body !== data.items.body || historyData[0].body === '')))">
											<div class="popup-details__content popup-details__content--label" v-if="historyData"><span>Note History:</span><span style="float:right !important">Updated</span></div>
											<template  v-for="(item) in historyData">
												<div class="popup-details__content-history" v-if="!(item.body === data.items.body) || edited" v-bind:key="item.id">
													<div style="display: flex; align-items: center; padding: 5px 0; font-size: 14px; justify-content: space-between">
														<div style="display: flex; align-items: center;">
															<span style="width: 12px; min-width: 12px; height: 12px; display: block; border-radius: 50%; left: 0;" v-bind:style="{'background': item.color}"></span>
															<span class="pl-2" v-html="item.stage_name"></span>
														</div>
														<span> {{ changeDateFormat(item.created_at) }}</span>
													</div>
													<div style="width:100%; justify-content: space-between;">
														<span class="popup-details__content popup-details__content--text" style="margin-left:5px" v-if="!!item.datepicker && item.popup_date && (item.popup_date !== '0' && item.popup_date !== '' )">({{ changeDateFormat(item.popup_date) }})</span>
														<div>
															<span class="popup-details__content popup-details__content--text" style="display:flex">-
																<pre v-html="item.body" style="margin-left:5px"></pre>
															</span>
														</div>													
													</div>
												</div>
											</template>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="popup-form__wrap-close-popup">
					<a href="javascript:" @click="closePopup">
						<SvgIcon class="close-icon" iconName="ico-close-sm"/>
					</a>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import { formatDate } from '@/config/util';
import PartInputTextarea from '@/components/parts/PartInputTextarea';
import PartCalendar from '@/components/parts/PartCalendar';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			editingNote: false,
			active: '',
			DateTextNote: {
				inputId: 'note-input',
				classTextarea: 'note__textarea',
				inputVal: 'editedNoteValue',
				// maxlength: 125,
				placeholder: 'Note'
			},
			DataCalendar: {
				label: '',
				inputId: 'date_calendar-stage-input',
				labelId: 'date_calendar-stage-label',
				icon: false
			},
			oldBody: '',
			index: 0,
			old: {
				body: this.data.items.body,
				created_at: this.data.items.created_at,
				popup_date: this.data.items.popup_date
			},
			historyData: this.data.items.old_history_note ? this.data.items.old_history_note : [],
			loaded: false,
			lastId: null,
			edited: false
		};
	},
	watch: {
		data: { 
			deep: true,
			handler(value, old) {
				if (this.lastId !== this.data.items.id) {
					this.loaded = false;
				}
				if (this.lastId !== this.data.items.id && !this.loaded) {
					this.historyData = this.data.items.old_history_note ? this.data.items.old_history_note : [];
					this.old = {
						body: this.data.items.body,
						created_at: this.data.items.created_at,
						popup_date: this.data.items.popup_date
					};
					this.loaded = true;
					this.lastId = this.data.items.id;
				}
			}
		}
	},
	components: {
		SvgIcon,
		PartInputTextarea,
		PartCalendar
	},
	mixins: [onClickOutside],
	methods: {
		closePopup() {
			this.$emit('closePopupForm');
			this.active = '';
		},
		changeDateFormat(date) {
			return formatDate(date);
		},
		editNote(index, item) {
			this.oldBody = item.body;
			this.active = item.id;
			if (item.popup_date !== '0') {
				this.$refs.note_calendar.setValue(item.popup_date);
			} else {
				// const now = new Date(Date.now()).toLocaleString('en').split(',')[0];
				this.$refs.note_calendar.setValue();
			}
		},
		saveNote(item) {
			// this.data.items.old_history_note.push(this.data.items);
			// const now = new Date(Date.now()).toLocaleString('en').split(',')[0];
			if (this.old.body !== item.body || item.body === '') {
				this.old.body = item.body;
				this.edited = false;
				this.active = '';
				const obj = {
					id: item.id,
					body: item.body,
					note_row_id: item.note_row_id,
					popup_date: item.popup_date && (item.popup_date.toString()).length > 5 ? item.popup_date : '',
					datepicker: item.datepicker
				};
				this.$store.dispatch('updateStageNote', obj).then(res => {	
					const data = {
						id: res.data.history.id,
						body: res.data.history.body,
						created_at: res.data.history.created_at,
						popup_date: res.data.history.popup_date,
						stage_name: res.data.history.stage_name,
						color: res.data.history.color,
						datepicker: res.data.history.datepicker
					};

					if (this.historyData.length) {
						this.historyData = res.data.history.old_history_note;
						this.historyData.unshift(data);
					} else {
						this.historyData = [data];
					}
					// this.historyData.map(hd => { if (hd.popup_date === '0') return hd; });
				}); 
			}
		},
		closeNote() {
			this.data.items.popup_date = this.old.popup_date;
			this.data.items.body = this.oldBody;
			this.active = '';
		}
	}
};
</script>

<style lang="scss">
pre {
	background: none;
	font-family: inherit;
	font-size: 14px;
	word-break: break-word;
	padding: 0;
	margin-bottom: 0;
}
.popup-details__content-history-wrap {
	padding-top: 10px;
}
.popup-details__content-history {
	// display: flex;
	// justify-content: space-between;
}
.popup-details__content-note {
	display: flex;
	width: 100%;
    justify-content: space-between;
	align-items: center;

	a {
		align-self: baseline;
		margin-left: 10px;
	}
}
.color-picker__item {
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    font-family: $font-main;
    font-size: 14px;
    line-height: 1.2;
    color: $fiord;
	margin-bottom: 5px;
}

.color-picker__item-color {
	width: 12px;
	min-width: 12px;
	height: 12px;
	display: block;
	border-radius: 50%;
	margin-right: 10px;
	position: relative !important;

	@include mq(440px) {
		width: 10px;
		min-width: 10px;
		height: 10px;
		margin-right: 5px;
	}
}

.color-picker__item-date {
    font-family: $font-main;
    font-size: 14px;
    line-height: 1.2;
    color: $shuttle-gray;
    opacity: 0.5;
    padding: 0 10px 0;
	display: block;
	margin-left: auto;
}

.popup-form__overlay {
	position: fixed;
    top: 0;
    left: 0;
	bottom: 0;
	right: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: rgba($slate-gray, .5);
}

.popup-form__box {
	z-index: 101;
}

.popup-form__wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 9999999;
    display: flex;
    justify-content: center;
    align-items: center;
}
.popup-form {
    max-width: 475px;
    padding: 23px 27px 28px 21px;
    width: 100%;
    background-color: $white;
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 4px rgba($black, .25);
    border-radius: 8px;
    position: relative;
	max-height: 60vh;
	overflow-y: auto;

	&::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}

	&::-webkit-scrollbar-track {
		background: #eceeef;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #42526e;
		border-radius: 20px;
		border: 1px solid #eceeef;
	}
	scrollbar-width: thin;
	scrollbar-color: #42526e #eceeef;

    @include mq($lg) {
        padding: 40px 30px;
    }

    @include mq($sm) {
        padding: 40px 15px;
    }
}

.popup-form__title {
    margin-bottom: 14px;
    font-size: 20px;

    @include mq($lg) {
        font-size: 18px;
        margin-bottom: 20px;
    }

    @include mq($md) {
        font-size: 16px;
    }

    @include mq($sm) {
        font-size: 15px;
    }
}

.popup-form-title {
	font-family: $font-second;
	font-weight: 500;
	font-size: 20px;
	line-height: 23px;
	color: $fiord;
	text-align: left;
}

.popup-form__inner {
    display: flex;
	flex-direction: column;
    max-width: 100%;
    width: 100%;
}

.popup-form__btn {
    margin-left: auto;
    max-width: 96px;
    display: flex;
}

.close-icon {
    position: absolute;
    right: 15px;
    top: 15px;
	color: $fiord;
	font-size: 20px;
	transition: $dur $ease;
	cursor: pointer;

	@include hover {
		color: $dodger-blue;
	}
}

.popup-details {
	position: absolute;
	left: -17px;
	z-index: 9;
	width: 476px;
	top: 47px;
	transition: $dur $ease;

	@include mq($xl) {
		top: 20px;
	}

	@include mq($md) {
		left: 50%;
		top: 30px;
		width: auto;
		transform: translateX(-50%);
	}
}

.popup-details__title {
    margin-bottom: 18px;
    font-size: 20px;

    @include mq($md) {
        font-size: 18px;
        margin-bottom: 20px;
    }

    @include mq($md) {
        font-size: 16px;
    }

    @include mq($sm) {
        font-size: 15px;
    }
}

.popup-details__info-inner {
	display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 4px;
    margin-bottom: 14px;
	position: relative;

	@include mq($xl) {
		margin-bottom: 10px;
	}

	@include mq($md) {
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
	}

	&:not(:last-of-type) {
		border-bottom: 1px solid rgba(94, 108, 132, 0.2);
	}
}

.popup-details__content {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $fiord;
    display: block;
	word-break: break-word;

	@include mq($xl) {
		font-size: 13px;
	}
}

.popup-details__content--date {
	min-width: 80px;
	text-align: right;
}

.popup-details__content--text {
	span {
		word-break: break-word;
	}
}

.popup-details__content--label {
	opacity: 0.5;
}

.popup-details__content--input ol li {
    list-style-type: decimal;
    list-style-position: inside;
	opacity: 1;
	overflow: visible;
}

.popup-details__content--input ul li {
    list-style-type: disc;
    list-style-position: inside;
	opacity: 1;
	overflow: visible;
}

.last-item {
	flex-direction: column;
	justify-content: flex-start;
    align-items: flex-start;
}

.item-veritical {
	.popup-details__info-inner-content {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		width: 100%;
		align-items: baseline;
	}

	.popup-details__content--input {
		margin-left: 10px;
	}
}

.popup-details__info-inner-content--note {
	width: 100%;
}
</style>
